export const CloudFunctionName = {
    "generateVideocallToken": "generateVideocallToken",
    "createvideocallRoom": "createvideocallRoom"
}